import React, { useEffect, useState } from 'react'
import { VERIFY_COUPON_CODE, } from '../../Utils/apis';

const useApplyCoupon = (couponCode) => {
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [data, setData] = useState(undefined);

    const verifiyFunction = async (params) => {
        try {
            setLoading(true);
            const res = await fetch(VERIFY_COUPON_CODE, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: 'include',
                body: JSON.stringify({ type: params.plan_type, planName: params.plan_name, couponCode: params.couponCode })
            });

            if (!res.ok) {
                const error = await res.json();
                setData(error);
                throw new Error(error.message);
            };
            const data = await res.json();
            // console.log('Coupon verification data:', data);
            setData(data);
        } catch (err) {
            setError(err.message);
            // console.log('Error verifying coupon:', error);
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(()=>setData(undefined), [couponCode])

    return [loading, error, data, verifiyFunction];
}

export default useApplyCoupon;